import {useMutation, useQueryClient} from "@tanstack/react-query";
import {EventAPI} from "../../services/network/event-api";
import {EVENT_ENDPOINTS, RECOMMENDATION_ENDPOINTS} from "../../services/network/endpoints";
import {IEvent, IEventCreate} from "../../services/models/event";
import {toast} from "react-toastify";
import {RecommendationsApi} from "../../services/network/recommendation-api";
import {RecommendationComment} from "../../services/models/recommendation_comment";

export function useCreateRecommComment() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [RECOMMENDATION_ENDPOINTS.ADD_COMMENT],
        mutationFn: (createData: Partial<RecommendationComment>) => RecommendationsApi.createRecommendationComment(createData),
        onError() {
            toast.error("Ошибка добавления комментария");
        },

        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: [RECOMMENDATION_ENDPOINTS.GET, variables.recommendation] });
            toast.success("Комментарий добавлен");
        }
    });
}
